import { Directive, ElementRef, Input, OnInit, OnDestroy, Renderer2 } from '@angular/core';
import { Subscription } from 'rxjs';
import { skip } from 'rxjs/operators';
import { AuthorizationUtility } from './auth.utility';
import { AllowListAuthStore } from './allow-list-auth.store';

@Directive({
  standalone: true,
  selector: '[authorizeField]',
})
export class AuthorizeFieldDirective implements OnInit, OnDestroy {

  private id!: string;
  private section!: string;
  private pageId!: string;
  private tabId!: string;
  private configSub: Subscription;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    private authUtility: AuthorizationUtility,
    private authStore: AllowListAuthStore,
  ) {
    // Re-evaluate whenever auth config reloads (skip initial BehaviorSubject emission)
    this.configSub = this.authStore.loaded$.pipe(skip(1)).subscribe(() => {
      if (this.pageId) this.updateViewState();
    });
  }

  ngOnInit(): void {
    this.updateViewState();
  }

  ngOnDestroy(): void {
    this.configSub.unsubscribe();
  }

  @Input() set authorizeField(config: string[]) {
    this.pageId = config[0];
    this.tabId = config[1];
    this.section = config[2];
    this.id = config[3];
  }

  private updateViewState() {
    const element = this.el.nativeElement;
    const hasEditAccess = this.authUtility.isFieldEditable(this.pageId, this.tabId, this.section, this.id);

    if (!hasEditAccess) {
      if (element.tagName === 'NZ-DATE-PICKER') {
        element.nzDisabled = true;
      } else if (element.tagName === 'PPL-DATE-PICKER') {
        setTimeout(() => {
          const input = element.querySelector('input');
          if (input) {
            this.renderer.setAttribute(input, 'readonly', 'true');
            this.renderer.setAttribute(input, 'disabled', 'true');
          }
        });
      } else {
        this.renderer.setAttribute(element, 'readonly', 'true');
        this.renderer.setAttribute(element, 'disabled', 'true');
      }
      this.renderer.addClass(element, 'disabled');
    } else {
      // Re-enable when access is granted (e.g. role switch)
      if (element.tagName === 'NZ-DATE-PICKER') {
        element.nzDisabled = false;
      } else if (element.tagName === 'PPL-DATE-PICKER') {
        setTimeout(() => {
          const input = element.querySelector('input');
          if (input) {
            this.renderer.removeAttribute(input, 'readonly');
            this.renderer.removeAttribute(input, 'disabled');
          }
        });
      } else {
        this.renderer.removeAttribute(element, 'readonly');
        this.renderer.removeAttribute(element, 'disabled');
      }
      this.renderer.removeClass(element, 'disabled');
    }
  }
}
